import { nanoid } from 'nanoid'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import MessageBuble from './MessageBuble'

import './Messages.css'

const Messages = ({ nextMessage, clearMessages }) => {
    const [messageChain, setMessageChain] = useState([])
    const role = useSelector(state => state.role)

    useEffect(() => {
        if (!nextMessage.speaker) return

        addMessage(nextMessage.speaker, nextMessage.message)
        // eslint-disable-next-line
    }, [nextMessage])

    useEffect(() => {
        if(clearMessages) {
            const lastMessage = messageChain[messageChain.length - 1]
            if (lastMessage) {
                setMessageChain([lastMessage])
            }
        }
        // eslint-disable-next-line
    }, [clearMessages])

    const addMessage = (speaker, message) => {
        if (messageChain.length === 0) {
            const newMessage = {
                speaker: speaker,
                align: speaker === role ? 'right' : 'left',
                message: message
            }
            const messageBuble = <MessageBuble key={nanoid()} message={newMessage} />
            setMessageChain([messageBuble, ...messageChain])
            return
        }

        //const lastMessage = messageChain[messageChain.length - 1]
        const newMessage = {
            speaker: speaker,
            align: speaker === role ? 'right' : 'left',
            sameSpeaker: false, //lastMessage.props.message.speaker === speaker,
            message: message
        }
        const messageBuble = <MessageBuble key={nanoid()} message={newMessage} />
        setMessageChain([messageBuble, ...messageChain])
    }

    return (
        <div className='messages-container'>
            {messageChain.map((message) => { return message })}
        </div>
    )
}

export default Messages